import { createI18n } from 'vue-i18n'
import { useAppStore } from '@/stores/app'
import { getDefaultLang } from '@/utils/env'

const allLanguages = ['en', 'zh', 'ko', 'th', 'vi', 'my']
const isDev = import.meta.env.MODE === 'development'
const viewLanguageModules = isDev ? import.meta.glob('../ui/**/i18n.js') : {}

function deepMerge(target, source) {
  const result = { ...target }

  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (
        typeof source[key] === 'object' &&
        source[key] !== null &&
        !Array.isArray(source[key]) &&
        typeof target[key] === 'object' &&
        target[key] !== null &&
        !Array.isArray(target[key])
      ) {
        result[key] = deepMerge(target[key], source[key])
      } else {
        result[key] = source[key]
      }
    }
  }

  return result
}

async function loadDevLanguage(lang) {
  let mergedContent = {}

  try {
    const globalModule = await import(`./global/${lang}.js`)
    mergedContent = { ...globalModule.default }
  } catch (error) {
    console.error(`加载全局语言文件失败: ${lang}`, error)
  }

  for (const path in viewLanguageModules) {
    try {
      const module = await viewLanguageModules[path]()
      const messages = module.default
      if (messages[lang]) {
        mergedContent = deepMerge(mergedContent, messages[lang])
      }
    } catch (error) {
      console.error(`加载页面语言文件失败: ${path}`, error)
    }
  }

  return mergedContent
}

// 动态导入语言文件
const loadLanguage = async (lang) => {
  try {
    if (isDev) {
      return loadDevLanguage(lang)
    }

    // 在开发模式下，如果build目录不存在，则从global目录加载
    const module = await import(`./build/${lang}.js`)
    return module.default
  } catch (error) {
    console.error(`加载语言文件失败: ${lang}`, error)
    return {}
  }
}

// 从本地数据中读取当前语言
function getLanguageFromLocalStorage() {
  const localStorageData = localStorage.getItem('app')
  if (localStorageData) {
    try {
      const { language } = JSON.parse(localStorageData)
      if (language && language.trim() !== '') {
        return language
      }
    } catch (error) {
      // Ignore JSON parse errors
    }
  }
  return getDefaultLang()
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  globalInjection: true, // 全局注入 $t, $d, $n 等函数
  locale: getLanguageFromLocalStorage(),
  messages: {},
})

i18n.global.init = () => {
  const appStore = useAppStore()

  appStore.initLanguage(allLanguages, (lang) => {
    if (!i18n.global.messages[lang]) {
      loadLanguage(lang).then((messages) => {
        const existingTranslations = i18n.global.messages[lang] || {}
        console.log(lang, ', ', messages)
        i18n.global.setLocaleMessage(lang, { ...existingTranslations, ...messages })
        i18n.global.locale.value = lang
      })
      return true
    } else {
      i18n.global.locale.value = lang
      return true
    }
  })
}

export default i18n
